export class PaymentsFirms {
  constructor() {}
  d: number;
  s: string;
}
